import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Close = (props: IconProps) => (
  <Icon width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.5 0.5L0.5 9.5M9.5 9.5L0.5 0.5" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
